const uploadStatus = document.getElementById('provider-upload-status');
const input = document.getElementById('provider-upload-file') as HTMLInputElement;
const uploadButton = document.getElementById('provider-upload-js') as HTMLButtonElement;
const siteID = uploadButton.getAttribute("data-sitesetting-id");
// This will upload the file after having read it 
const upload = (file) => {
    uploadStatus.innerHTML = '<p> Uploading Started </p> ';
    fetch(`/api/importer/Provider?siteSettingId=${siteID}`, { // Your POST endpoint
        method: 'POST',
        headers: {
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet "
        },
        body: file // This is your file object
    }).then(
        result => handleResponse(result)
    ).catch(
        error => console.log(error) // Handle the error response object
    );
};

uploadButton.onclick = (evt) => {
    evt.preventDefault();
    upload(input.files[0])
}

const handleResponse = (result:Response) => {
    if (result.status == 200) {
        result.json().then(json => parseStatus(json));
    }

}

// Add a listener on your input
// It will be triggered when a file will be selected
const parseStatus = (json: any) => {
    uploadStatus.innerHTML = `<p> ${json.message}</p>`;
    if (json.error) {
        console.log(json.error.split(','));
        json.error.split(',').filter(item => item != "").map(item => uploadStatus.innerHTML += `<li>${item}</li>`);
    }

}